export const  DRIVERLOCATION={
    driver_Location: "driver_Location",
};
  